import { ThemeModeAction } from '../actions/themeModeActions';
import { AppThemeMode, FORCED_DARK_THEME_MODE, FORCED_LIGHT_THEME_MODE, FROM_DEVICE_THEME_MODE,  PREFERRED_THEME_MODE_LOCAL_STORAGE_KEY } from '../models/theme';

export const themeModeReducer = (themeMode: AppThemeMode, action: ThemeModeAction): AppThemeMode => {
    switch (action.type) {
        case 'SWITCH_THEME_MODE':
            switch (themeMode) {
            case  FORCED_LIGHT_THEME_MODE:
                themeMode = FORCED_DARK_THEME_MODE;
                break;
            case FORCED_DARK_THEME_MODE:
                themeMode = FROM_DEVICE_THEME_MODE;
                break;
            case FROM_DEVICE_THEME_MODE:
                themeMode = FORCED_LIGHT_THEME_MODE;
                break;
            default:
                themeMode = FORCED_LIGHT_THEME_MODE;
                break;
            }
            localStorage.setItem(PREFERRED_THEME_MODE_LOCAL_STORAGE_KEY, themeMode);
            console.log(`Theme mode changed to: ${themeMode}`);
            return themeMode;
        default:
            return themeMode;
    }
};
